import React, { PureComponent } from 'react';

class ButtonDenegar extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { denegarAjuste, ajuste } = this.props;
        return (<a className="clickable none-text-decoration glyphicon glyphicon-remove" aria-hidden="true" onClick={() => this.props.denegarAjuste(ajuste, 7)}></a>);
    }
}

export default ButtonDenegar;